import React, { FC } from 'react';
import { Paper, Table, TableBody, TableContainer } from '@mui/material';
import { CommonProps, ICategory } from './constants';
import { TableHeader } from './TableHeader';
import { TableRowsPanel } from './TableRowsPanel';

interface Props extends CommonProps {
  data: Array<ICategory>;
  selectedParent?: number;
  setSelectedParent?: (id: number) => void;
}
export const Container: FC<Props> = (props) => (
  <Paper>
    <TableContainer>
      <Table
        sx={{
          '@media (max-width: 599.95px)': {
            '& thead': { display: 'none' },
            '& tbody, & tr, & td': { display: 'block' },
            '& tr': {
              position: 'relative',
              border: '1px solid var(--border)',
              borderRadius: '8px',
              mb: 1,
              p: 1.25,
            },
            '& td': {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: 'none',
              padding: '3px 0',
              textAlign: 'right',
              fontSize: 12.5,
              lineHeight: 1.4,
            },
            '& td::before': {
              content: 'attr(data-label)',
              fontWeight: 500,
              color: 'var(--text-2)',
              marginRight: '12px',
            },
            '& td:first-of-type': {
              paddingRight: '32px',
              paddingBottom: '6px',
              marginBottom: '4px',
              borderBottom: '1px solid var(--border)',
              fontWeight: 600,
            },
            '& td:first-of-type::before, & td:last-of-type::before': {
              display: 'none',
            },
            '& td:last-of-type': {
              position: 'absolute',
              top: '6px',
              right: '6px',
              padding: 0,
              border: 'none',
            },
          },
        }}
      >
        <TableHeader {...props} />
        <TableBody>
          <TableRowsPanel {...props} />
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);
